import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { format, startOfMonth } from 'date-fns';
import { keys } from './keys';

type AiUsage = {
  calls: number;
  costUsd: number;
  limitUsd: number;
};

async function fetchAiUsage(spaceId: string): Promise<AiUsage> {
  const month = format(startOfMonth(new Date()), 'yyyy-MM-dd');

  // The limit comes from the same SQL function the edge functions use.
  const [usageResult, limitResult] = await Promise.all([
    apiClient
      .from('ai_usage_monthly')
      .select('calls, cost_usd')
      .eq('space_id', spaceId)
      .eq('month', month)
      .maybeSingle(),
    apiClient.rpc('ai_monthly_limit_usd', { _space_id: spaceId }),
  ]);

  if (usageResult.error) {
    throw usageResult.error;
  }
  if (limitResult.error) {
    throw limitResult.error;
  }

  return {
    calls: usageResult.data?.calls ?? 0,
    costUsd: Number(usageResult.data?.cost_usd ?? 0),
    limitUsd: Number(limitResult.data),
  };
}

export default function useGetAiUsage(spaceId: string | undefined) {
  return useQuery({
    queryKey: keys.aiUsage(spaceId ?? ''),
    queryFn: () => fetchAiUsage(spaceId!),
    enabled: !!spaceId,
  });
}
